export const isSvgOrEncodedImage = (url: string) => {
    const [canonical] = url.split('?')
    return canonical.startsWith('data:image') || canonical.endsWith('.svg')
}
